if (!customElements.get('responsive-video')) {
  customElements.define('responsive-video', class ResponsiveVideo extends HTMLElement {
    constructor () {
      super();
      this.onResize = this.onResize.bind(this);
      this.onIntersection = this.onIntersection.bind(this);
      this.observer = null;
      const width = window.innerWidth;
      this.device = (width >= 750) ? 'desktop' : 'mobile';
    }

    connectedCallback () {
      this.setVideoSource();
      window.addEventListener('resize', this.onResize);

      if (this.hasAttribute('play-on-intersect')) {
        const video = this.querySelector('video');
        if (video) {
          video.removeAttribute('autoplay');
          video.pause();
        }
        this.setupIntersection();
      } else {
        this.tryPlay().then();
      }
    }

    disconnectedCallback () {
      window.removeEventListener('resize', this.onResize);
      this.teardownIntersection();
      this.unsetVideoSource();
    }


    setupIntersection () {
      if (this.observer) return;
      this.observer = new IntersectionObserver(this.onIntersection, {
        root: null,

        rootMargin: '0px 0px -10% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });
      this.observer.observe(this);
    }

    teardownIntersection () {
      if (this.observer) {
        this.observer.unobserve(this);
        this.observer.disconnect();
        this.observer = null;
      }
    }

    onIntersection (entries) {
      const entry = entries[0];
      const video = this.querySelector('video');
      if (!video) return;

      if (entry.isIntersecting && entry.intersectionRatio > 0.25) {

        this.tryPlay().then();
      } else {

        video.pause();
      }
    }

    onResize () {
      const width = window.innerWidth;
      const currentDevice = (width >= 750) ? 'desktop' : 'mobile';
      if (currentDevice !== this.device) {
        this.device = currentDevice;
        this.setVideoSource(true /* switching */);
      }
    }

    unsetVideoSource () {
      const video = this.querySelector('video');
      if (!video) return;

      try { video.pause(); } catch(e){}
      try { video.currentTime = 0; } catch(e){}
      video.removeAttribute('poster');

      const sources = video.querySelectorAll('source');
      sources.forEach((source) => {
        source.removeAttribute('src');
      });

      try { video.load(); } catch(e){}
    }

    setVideoSource (forceReattach = false) {
      const device = this.device;
      const video = this.querySelector('video');
      if (!video) return;

      const posterAttr = video.getAttribute(`data-poster-${device}`);
      if (posterAttr) video.poster = posterAttr;

      const sources = video.querySelectorAll('source');
      let changed = false;

      sources.forEach((source) => {
        const sourceDevice = source.dataset.device;
        if (sourceDevice === device) {
          const wanted = source.dataset.src || '';
          if (source.src !== wanted) {
            source.src = wanted;
            changed = true;
          }
        } else if (source.hasAttribute('src')) {
          source.removeAttribute('src');
          changed = true;
        }
      });

      if (forceReattach || changed) {
        video.load();
        if (!this.hasAttribute('play-on-intersect')) {
          this.tryPlay().then();
        }
      }
    }

    async tryPlay () {
      const video = this.querySelector('video');
      if (!video) return;
      video.muted = video.muted !== false ? true : video.muted;
      video.setAttribute('playsinline', '');
      try {
        await video.play();
      } catch (error) {

      }
    }
  });
}